import PropTypes from "prop-types"
import React from "react"

import { withTranslation } from "../../../i18n/translate"
import ContactSalesBanner from "../contact-sales-banner/contact-sales-banner"
import { filterProductParameterGroupsByProducts } from "../product-param-helpers"
import ProductPreview from "../product-preview/product-preview"
import "./product-list.sass"

class ProductList extends React.Component {
  constructor(props) {
    super(props)

    const { productsDatabase } = props

    this.state = {
      filteredProducts: productsDatabase.getFilteredProducts(),
      listIsFiltered: productsDatabase.hasFilters(),
      productContext: productsDatabase.getProductContext(),
      isClient: false,
    }

    this.calculateNewState()

    this.onUpdateHandle = productsDatabase.onUpdate(() => {
      this.calculateNewState()
      this.setState({
        filteredProducts: productsDatabase.getFilteredProducts(),
        listIsFiltered: productsDatabase.hasFilters(),
        productContext: productsDatabase.getProductContext(),
      })
    })
  }

  componentDidMount() {
    this.setState({ isClient: true })
  }

  componentWillUnmount() {
    this.onUpdateHandle.unsubscribe()
  }

  calculateNewState() {
    const productParamGroups = filterProductParameterGroupsByProducts(
      this.props.productParamGroups,
      this.state.filteredProducts,
    ).filter((group) => !group.hidden)
    this.productParamGroups = productParamGroups
  }

  render() {
    const { t } = this.props
    const { isClient } = this.state

    return (
      <div className={"_fp-product-list"}>
        {isClient &&
          (this.state.listIsFiltered ||
            this.state.filteredProducts.length < 10) && (
            <div className="_fp-banner">
              <ContactSalesBanner
                infoSectionStyle={"tile"}
                products={this.state.filteredProducts}
              />
            </div>
          )}
        <div className={"_fp-product-list__list"}>
          {this.state.filteredProducts
            .sort((a, b) => a.name.localeCompare(b.name))
            .map((product, index) => (
              <ProductPreview
                productContext={this.state.productContext}
                filterKey={this.props.filterKey}
                key={`product-list-${index}`}
                product={product}
              />
            ))}
        </div>
      </div>
    )
  }
}

ProductList.propTypes = {
  productsDatabase: PropTypes.object.isRequired,
  filterKey: PropTypes.string,
}

export default withTranslation()(ProductList)
